import {
  type QuestionConfig,
  type QuestionConfigOption,
} from "@/screens/prequal/questions"
import { Body, H6, Small } from "@/components/standard/BFText"
import { Horizontal, Vertical } from "@/components/standard/BFLayout"
import { usePreQualState } from "@/stores/preQual"
import { Container } from "@/screens/rewards/components/Container"
import { Pressable, View } from "react-native"
import CheckCircle from "phosphor-react-native/src/icons/CheckCircle"
import Circle from "phosphor-react-native/src/icons/Circle"
import { BFColors } from "@/constants/Colors"

export const IntentStatusQuestion = ({
  question,
  onValueChange,
}: {
  question: QuestionConfig
  onValueChange: (val: string) => void
}) => {
  const preQualState = usePreQualState()
  const value = preQualState[question.questionValue] as string

  const options: QuestionConfigOption[] =
    typeof question.options?.[0] === "string"
      ? question.options.map((option) => ({
          value: option as string,
          label: option as string,
        }))
      : (question.options as QuestionConfigOption[])

  const displayValue = question.displayValue!

  return (
    <View>
      <Body color={"primary"} className={"mb-3"}>
        {question.subTitle}
      </Body>
      <Container className={"p-0"}>
        {options.map((option, index) => {
          return (
            <Pressable
              testID={`${question.questionKey}-option-${index}`}
              key={option.value}
              className={"hover:bg-grey py-1 px-4"}
              onPress={() => {
                onValueChange(option.value!)
              }}
            >
              <Horizontal
                key={option.value}
                className={"justify-between items-center py-2"}
              >
                <Vertical>
                  <H6 key={option.value}>{displayValue(option.value)}</H6>
                  <Small color={"disabled"}>{option.label}</Small>
                </Vertical>

                {value === option.value ? (
                  <CheckCircle
                    color={BFColors.calmBlue}
                    size={20}
                    weight="fill"
                  />
                ) : (
                  <Circle color={BFColors.calmBlue} size={20} />
                )}
              </Horizontal>
            </Pressable>
          )
        })}
      </Container>
    </View>
  )
}
